import React, { useState } from 'react';

// Inject FontAwesome CDN link directly to display real icons (if your project hasn't installed it yet)
document.getElementById('fa-cdn') || (() => {
  const link = document.createElement('link');
  link.id = 'fa-cdn';
  link.rel = 'stylesheet';
  link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css';
  document.head.appendChild(link);
  return link;
})();

// Expand the list to 15 visual icons specifically for booking/hotels
const AVAILABLE_ICONS = [
  { label: 'Water Car', value: 'fa-solid fa-truck-droplet', color: '#f59e0b' },
  { label: 'Water Bootle', value: 'fa-solid fa-bottle-water', color: '#06b6d4' },
  { label: '24/7 Support', value: 'fa-solid fa-headset', color: '#8b5cf6' },
  { label: 'Pets Allowed', value: 'fa-solid fa-paw', color: '#b45309' },
  { label: 'Swimming Pool', value: 'fa-solid fa-person-swimming', color: '#0284c7' },
  { label: 'No Smoking', value: 'fa-solid fa-ban-smoking', color: '#dc2626' },
  { label: 'Infant / Crib', value: 'fa-solid fa-baby', color: '#ec4899' },
  { label: 'Bar / Lounge', value: 'fa-solid fa-glass-martini-alt', color: '#dd2476' },
  { label: 'Card Payment', value: 'fa-solid fa-credit-card', color: '#0f172a' },
  { label: 'Laundry', value: 'fa-solid fa-shirt', color: '#0284c7' },
];

export default function SettingDatabase() {
  // 1. Actual room data variable (to test show/hide feature)
  const [other1, setOther1] = useState("Vip room with wifi and non breakfast");

  // 2. Pre-created configuration list as sample
  const [configs, setConfigs] = useState([
    { id: "1", iconClass: "fa-solid fa-bowl-rice", keyword: "non breakfast" },
    { id: "2", iconClass: "fa-solid fa-wifi", keyword: "wifi" },
    { id: "3", iconClass: "fa-solid fa-star", keyword: "vip" }
  ]);

  // 3. State for Add New Form
  const [selectedIcon, setSelectedIcon] = useState(AVAILABLE_ICONS[0].value);
  const [keyword, setKeyword] = useState("");

  // Function to add new configuration
  const handleAdd = (e) => {
    e.preventDefault();
    if (!keyword.trim()) return;

    const newRule = {
      id: Date.now().toString(),
      iconClass: selectedIcon,
      keyword: keyword.trim().toLowerCase()
    };

    setConfigs([...configs, newRule]);
    setKeyword("");
  };

  // Function to delete configuration
  const handleDelete = (id) => {
    setConfigs(configs.filter(item => item.id !== id));
  };

  // 4. MAIN LOGIC: Filter and automatically render positions (left1, left2...) with real icons
  const renderIcons = () => {
    const activeIcons = configs.filter(config => 
      other1.toLowerCase().includes(config.keyword.toLowerCase())
    );

    return activeIcons.map((config, index) => {
      const finalClassName = `${config.iconClass} show-small-icon_left${index + 1}`;
      
      // Get the defined color for a beautiful preview interface
      const iconMeta = AVAILABLE_ICONS.find(i => i.value === config.iconClass);

      return (
        <div 
          key={config.id} 
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px',
            padding: '6px 12px', 
            background: '#f8fafc', 
            border: '1px solid #cbd5e1',
            borderRadius: '6px', 
            fontSize: '13px' 
          }}
          title={`Actual CSS class applied: ${finalClassName}`}
        >
          {/* Display real icon visually */}
          <i className={config.iconClass} style={{ color: iconMeta?.color || '#334155', fontSize: '16px' }}></i>
          <span style={{ color: '#64748b', fontSize: '11px' }}>➔ Class: <b>left{index + 1}</b></span>
        </div>
      );
    });
  };

  return (
    <div style={{ padding: '25px', fontFamily: 'sans-serif', maxWidth: '750px', margin: '0 auto', backgroundColor: '#fff', borderRadius: '12px', boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)' }}>
      <h3 style={{ margin: '0 0 5px 0', color: '#1e293b' }}>⚙️ Visual Icon Setup</h3>
      <p style={{ color: '#64748b', fontSize: '14px', marginTop: '0', marginBottom: '20px' }}>Select an icon image and type the keyword to search in the `Other1` variable to trigger rendering.</p>

      {/* Step 1: Change actual data for testing */}
      <div style={{ marginBottom: '20px' }}>
        <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '6px', color: '#334155', fontSize: '14px' }}>
          Current room `Other1` data:
        </label>
        <input 
          type="text" 
          value={other1} 
          onChange={(e) => setOther1(e.target.value)} 
          style={{ width: '100%', padding: '10px', boxSizing: 'border-box', border: '1px solid #cbd5e1', borderRadius: '6px', fontSize: '14px' }}
          placeholder="Enter room info (e.g., room with wifi, no smoking...)"
        />
      </div>

      {/* Step 2: Select Icon from Visual Grid */}
      <div style={{ marginBottom: '20px' }}>
        <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '8px', color: '#334155', fontSize: '14px' }}>
          Click to select an icon below:
        </label>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fill, minmax(110px, 1fr))', 
          gap: '8px', 
          maxHeight: '160px', 
          overflowY: 'auto', 
          padding: '8px', 
          border: '1px solid #cbd5e1', 
          borderRadius: '6px',
          backgroundColor: '#f8fafc'
        }}>
          {AVAILABLE_ICONS.map(icon => (
            <div 
              key={icon.value}
              onClick={() => setSelectedIcon(icon.value)}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '6px',
                padding: '10px 5px',
                border: selectedIcon === icon.value ? '2px solid #3b82f6' : '1px solid #e2e8f0',
                backgroundColor: selectedIcon === icon.value ? '#eff6ff' : '#fff',
                borderRadius: '6px',
                cursor: 'pointer',
                textAlign: 'center',
                transition: 'all 0.2s'
              }}
            >
              <i className={icon.value} style={{ color: icon.color, fontSize: '18px' }}></i>
              <span style={{ fontSize: '11px', color: '#475569' }}>{icon.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Step 3: Condition creation form */}
      <form onSubmit={handleAdd} style={{ display: 'flex', gap: '10px', marginBottom: '25px' }}>
        <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '10px', border: '1px solid #cbd5e1', borderRadius: '6px', padding: '0 10px', backgroundColor: '#fff' }}>
          <span style={{ fontSize: '13px', color: '#64748b', whiteSpace: 'nowrap' }}>Matching keyword:</span>
          <input 
            type="text" 
            value={keyword} 
            onChange={e => setKeyword(e.target.value)} 
            placeholder="Example: vip, wifi, non breakfast..." 
            style={{ width: '100%', padding: '10px 0', border: 'none', outline: 'none', fontSize: '14px' }}
          />
        </div>
        <button type="submit" style={{ padding: '0 20px', background: '#2563eb', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px' }}>
          Add Rule
        </button>
      </form>

      {/* Step 4: Current rules list */}
      <div style={{ marginBottom: '25px' }}>
        <b style={{ fontSize: '14px', color: '#334155' }}>Current list of rules:</b>
        <div style={{ marginTop: '8px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
          {configs.map(config => {
            const iconMeta = AVAILABLE_ICONS.find(i => i.value === config.iconClass);
            return (
              <div key={config.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', backgroundColor: '#f1f5f9', borderRadius: '6px', fontSize: '13px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <i className={config.iconClass} style={{ color: iconMeta?.color || '#334155', fontSize: '14px' }}></i>
                  <span>Show if data contains: <b style={{ color: '#1e293b' }}>"{config.keyword}"</b></span>
                </div>
                <button onClick={() => handleDelete(config.id)} style={{ color: '#ef4444', border: 'none', background: 'none', cursor: 'pointer', fontWeight: 'bold' }}>
                  Delete
                </button>
              </div>
            );
          })}
        </div>
      </div>

      {/* Step 5: Visual interface output result */}
      <div style={{ border: '2px dashed #2563eb', padding: '15px', borderRadius: '8px', background: '#f0f6ff' }}>
        <h5 style={{ margin: '0 0 12px 0', color: '#1e3a8a', fontSize: '14px' }}>👀 Actual display on screen:</h5>
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', minHeight: '32px', alignItems: 'center' }}>
          {renderIcons().length > 0 ? renderIcons() : <span style={{ color: '#94a3b8', fontSize: '13px' }}>No icons rendered yet. (Modify the data box in Step 1 to match the keywords of the Rules above).</span>}
        </div>
      </div>
    </div>
  );
}